import { createContext } from 'react';
import { StatusMasterType } from '../services/master.service';

export interface StatusColourEntry {
  colour: string;
  label: string;
}

export interface StatusColourContextValue {
  getColour: (type: StatusMasterType, id?: number | null) => StatusColourEntry | undefined;
  refresh: () => void;
}

export const StatusColourContext = createContext<StatusColourContextValue>({
  getColour: () => undefined,
  refresh: () => {},
});
